/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Class_Stringcontainsandaspect13Inputs */

const de__class_stringcontainsandaspect13 = /** @type {(inputs: _Class_Stringcontainsandaspect13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`beinhaltet alle von`)
};

/**

* @param {_Class_Stringcontainsandaspect13Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _class_stringcontainsandaspect13 = /** @type {((inputs?: _Class_Stringcontainsandaspect13Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Class_Stringcontainsandaspect13Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__class_stringcontainsandaspect13(inputs)
});
export { _class_stringcontainsandaspect13 as "_class_StringCONTAINSANDAspect" }